import { sendToApi } from 'api/client'
import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { UseQueryOptions, useQuery } from 'react-query'

type Data = { external_integrations: ExternalIntegration[] }

export const useTestIntegrations = (options?: Partial<UseQueryOptions<Data>>) => {
  return useQuery<Data>(
    ['test_integrations'],
    async () => {
      const res = await sendToApi('/instagram_integrations')
      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error()
      }
      return res.data
    },
    {
      refetchOnWindowFocus: false,
      ...options,
    },
  )
}
